import { Button, Flex } from "@chakra-ui/react";
import { RiEditLine, RiEyeLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { AdminCard } from "src/components/Layout/AdminCard";

export interface Props {
  title: string;
  description?: string | null;
  tag?: React.ReactNode;
  switches?: React.ReactNode;
  actionSwitch?: React.ReactNode;
  footerInfo?: React.ReactNode;
  previewRoute?: string;
  onPreviewClick?: () => void;
  editRoute?: string;
  onEditClick?: () => void;
  templateDisabled?: boolean;
  alert?: React.ReactNode;
}

export const FormTemplateDefaultCard: React.FC<Props> = ({
  tag,
  title,
  description,
  switches,
  actionSwitch,
  footerInfo,
  previewRoute,
  onPreviewClick,
  editRoute,
  onEditClick,
  templateDisabled,
  alert,
}) => {
  return (
    <AdminCard
      tag={tag}
      alert={alert}
      disabled={templateDisabled}
      title={title}
      description={description}
      switches={switches}
      actions={
        actionSwitch ||
        previewRoute ||
        editRoute ||
        onEditClick ||
        onPreviewClick ? (
          <Flex gap={2} alignItems="center" height="fit-content">
            {actionSwitch && <Flex mr={4}>{actionSwitch}</Flex>}

            {previewRoute && (
              <Button
                as={NavLink}
                to={previewRoute}
                aria-label={`Preview ${previewRoute}`}
                colorScheme="gray"
                variant="outline"
                leftIcon={<RiEyeLine />}
                size="sm"
              >
                Preview
              </Button>
            )}

            {onPreviewClick && (
              <Button
                aria-label="Preview action click"
                colorScheme="gray"
                variant="outline"
                leftIcon={<RiEyeLine />}
                size="sm"
                onClick={onPreviewClick}
              >
                Preview
              </Button>
            )}

            {editRoute && (
              <Button
                as={NavLink}
                to={editRoute}
                aria-label={`Edit ${editRoute}`}
                colorScheme="gray"
                variant="outline"
                leftIcon={<RiEditLine />}
                size="sm"
              >
                Edit
              </Button>
            )}

            {onEditClick && (
              <Button
                aria-label="Edit action click"
                colorScheme="gray"
                variant="outline"
                leftIcon={<RiEditLine />}
                size="sm"
                onClick={onEditClick}
              >
                Edit
              </Button>
            )}
          </Flex>
        ) : null
      }
    >
      {footerInfo}
    </AdminCard>
  );
};
